import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import ShapeAnimation from '../../ShapeAnimation';
const settings = {
  // dots: true,
  nav: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  lazyLoad: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};
const FeaturedSolutions = () => {
  const featurobj = [
    {
      id: 1,
      img: "assets/img/hospital.webp",
      heading: "Hospital Management System",
      para: "A Complete Web Based Solutions that covers the management of all the domains of Medical Institutions and can be easily customizable as per the need of any hospital or Health Care Institution.",
    },
    {
      id: 2,
      img: "assets/img/school.webp",
      heading: "School Management System",
      para: "Meet our School Management ERP to Automate, Track & Manage all the aspects of Your Educational Institution and Ensure Quick & Accurate Results.",
    },
    {
      id: 3,
      img: "assets/img/loyalty-card.webp",
      heading: "Loyalty Management System",
      para: "Our Top Rated & Robust System designed to Boost Repeat Sales & Improving Customer Interaction. Create, Manage & Ensure your Bonding with Existing customers with personalized Loyalty Program.",
    },
    {
      id: 4,
      img: "assets/img/online-shop.webp",
      heading: "E-Commrece Services",
      para: "We develop best customized E Commerce solutions to simply user journeys, increase customer/seller outreach, and deliver exceptional experiences with our proven time-cost customized approaches.",
    },
    {
      id: 5,
      img: "assets/img/business.webp",
      heading: "On-demand Service Apps",
      para: "Our fully customizable On-demand service apps serves as a mediator between a business and a customer,  allowing them to find each other in the first place and engage in a customer-provider relationship on mutually satisfactory terms.",
    },
    {
      id: 6,
      img: "assets/img/ott.webp",
      heading: "OTT Platform",
      para: "Enjoy our featured & scalable OTT platform with superior user experience and user interface. Solution offers unparalleled flexibility, affordable cost & an end-to-end platform for sharing, recording & playback your video content.",
    },
  ]
  return (
    <div>
      <section className="solutions-area pt-5 pb-4">
        <div className="container">
          <div className="section-title">
            {/* <span class="sub-title">What We Offer</span> */}
            <h2 className='fontkumbh'>Our Featured Solutions</h2>
            <div className="bar" />
            <p>
              Explore our cutting edge innovative solutions designed to streamline your business and boost productivity. From simplifying complex processes to enhancing efficiency, Our featured Solutions are intended for adding more value to businesses, gear up the productivity and attain the new business heights.
            </p>
          </div>
          <div className="main-slide" >
            {/* <div className="slider slider-nav-n" data-slick='{"slidesToShow": 4, "slidesToScroll": 4}'> */}
            <div className="slider slider-nav-n" data-slick='{"slidesToShow": 4, "slidesToScroll": 4}'>
              <Slider {...settings}>
                {featurobj.map((featurcard) => {
                  return <div className="featur-hd-card" key={featurcard.id}>
                    <div className="single-solutions-box">
                      <div className="icon">
                        <img src={featurcard.img} alt="Feature Images" loading="lazy" style={{ height: 50, width: 50 }} />
                      </div>
                      <h3 className='fontkumbh'>{featurcard.heading}</h3>
                      <p>{featurcard.para}</p>
                      {/*  <a href="#" class="learn-more-btn"><i data-feather="plus-circle"></i> Learn More</a> */}
                    </div>
                  </div>
                })}
              </Slider>
            </div>
          </div>
        </div>
        <ShapeAnimation />
      </section>
      <div className="about-area home-about mb-4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="ml-about-img">
                <img
                  src="assets/img/about-us-section.webp"
                  className="wow fadeInLeft"
                  data-wow-delay="0.6s"
                  alt="Feature Solution Images"
                  width="100%"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="ml-about-content">
                {/* <span class="sub-title">About Us</span> */}
                <h2 className='fontkumbh'>Engaging New Audiences Through Smart Approach</h2>
                <div className="bar" />
                <p className="text-justify">
                  We are a leading software development company in india that offers
                  unique, efficient and affordable web-based systems &amp; mobile apps
                  which helps enterprises to automate their processes, increase
                  productivity and facilitate workflow management. Alobha Technologies
                  is dedicated for meeting Client’s expectations through our team of
                  highly-skilled developers, creative project managers and top-notch
                  technologies.
                </p>{" "}
                <Link to="/about-us" className="btn btn-secondary read-more-css" >
                  Discover More
                </Link>
              </div>
            </div>
          </div>
        </div>
        <ShapeAnimation />
      </div>

    </div>
  )
}

export default FeaturedSolutions